import { useLocation } from "react-router";
import { BlockTitle } from "@blocks/Blocks";
import LoadMore from "@components/LoadMore/LoadMore";
import EventsAwardsNewsListingStories from "@events-awards/EventsAwardsNewsListingStories";
import {
  AwardType,
  EventsAwardsNewsContextData,
} from "@events-awards/utils/types";
import { useLoadMoreEventsNewsByKeywords } from "@hooks/useLoadMoreEventsNewsByKeywords";
import { compact } from "lodash-es";

/**
 * Component to render news section on News page for event and awards
 */
const EventsAwardsNews = ({
  articles,
  awardType,
}: EventsAwardsNewsContextData): React.ReactElement => {
  const matchedCategory = useLocation().pathname.replace("/", "");
  const isSIAAward = awardType === AwardType.SIA;
  const [parentCategory = "", childCategory = ""] = matchedCategory.split("/");
  const uniqueCategoryQuery = compact([
    parentCategory !== "keywords" && parentCategory,
    childCategory,
  ]).join("_");

  const { articleList, handleLoadMore, hasMoreArticles } =
    useLoadMoreEventsNewsByKeywords(
      articles,
      10,
      uniqueCategoryQuery,
      parentCategory
    );

  return (
    <section data-testdata-testid="events-news-component">
      {isSIAAward ? (
        <BlockTitle
          text="News"
          rootClassName="font-poppins text-4xl font-bold text-gray-850 font-medium md:text-6xl lg:text-8xl mb-2"
        />
      ) : null}

      <div className="stories">
        {articleList.map((articleProps, index) => {
          return (
            <EventsAwardsNewsListingStories
              key={index}
              articleProps={articleProps}
            />
          );
        })}
      </div>

      {hasMoreArticles ? (
        <LoadMore
          rootClassName="my-4"
          onLoadMore={handleLoadMore}
          hasMore={hasMoreArticles}
          loadText="load more"
        />
      ) : null}
    </section>
  );
};

export default EventsAwardsNews;
